const tunisia = [
    { "code": "Ariana", "name": "Ariana" },
    { "code": "Beja", "name": "Beja" },
    { "code": "Ben Arous", "name": "Ben Arous" },
    { "code": "Bizerte", "name": "Bizerte" },
    { "code": "Gabès", "name": "Gabès" },
    { "code": "Gafsa", "name": "Gafsa" },
    { "code": "Jendouba", "name": "Jendouba" },
    { "code": "Kairouan", "name": "Kairouan" },
    { "code": "Kasserine", "name": "Kasserine" },
    { "code": "Kebili", "name": "Kebili" },
    { "code": "Kef", "name": "Kef" },
    { "code": "Mahdia", "name": "Mahdia" },
    { "code": "Manouba", "name": "Manouba" },
    { "code": "Medenine", "name": "Medenine" },
    { "code": "Monastir", "name": "Monastir" },
    { "code": "Nabeul", "name": "Nabeul" },
    { "code": "Sfax", "name": "Sfax" },
    { "code": "Sidi Bouzid", "name": "Sidi Bouzid" },
    { "code": "Siliana", "name": "Siliana" },
    { "code": "Sousse", "name": "Sousse" },
    { "code": "Tataouine", "name": "Tataouine" },
    { "code": "Tozeur", "name": "Tozeur" },
    { "code": "Tunis", "name": "Tunis" },
    { "code": "Zaghouan", "name": "Zaghouan" }
]
export default tunisia;